import { createContext } from "react";
import IPointContext from './IPointContext'

const defaultPointContext: IPointContext = {}

export const PointContext = createContext(defaultPointContext)
const PointContextProvider = PointContext.Provider

export default PointContextProvider